import React from 'react';
import { MobileHeader } from './components/Header';
import MobileGreeting from './components/MobileGreeting';
import { MobileStatsSection } from './components/Stats';
import RecentInbox from './components/RecentInbox';
import MobileUpcomingMeetings from './components/MobileUpcomingMeetings';

const MobileDashboard = ({
  userData,
  dashboardStats,
  statsLoading,
  statsError,
  schedule,
  meetings,
  meetingsLoading,
  calendlyConnected,
  expandedCard,
  toggleCard
}) => {
  return (
    <>
      <MobileHeader />

      {/* Mobile Main Content */}
      <main className="flex-1 overflow-y-auto no-scrollbar pb-24">
        <div className="px-4 py-6 w-full">
          <MobileGreeting userName={userData.name} />

          <MobileStatsSection stats={dashboardStats} loading={statsLoading} error={statsError} />

          <RecentInbox />

          <div className="mt-8">
          <MobileUpcomingMeetings
            meetings={meetings}
            loading={meetingsLoading}
            calendlyConnected={calendlyConnected}
          />
          </div>
        </div>
      </main>
    </>
  );
};

export default MobileDashboard;
